module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-05.80c8a3ee.png";